import { NgClass, NgIf } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { UserService } from 'app/core/user/user.service';
import { PreferenceCalendarFilterType } from 'app/core/user/user.types';
import { TeamCalendarService } from './calendar.service';

@Component({
    selector: 'calendar-filter',
    templateUrl: './calendar-filter.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatMenuModule, NgIf, NgClass]
})
export class TeamCalendarFilterComponent implements OnInit
{
    selectedDaysFilter: 'all' | 'bookings' | 'no-bookings' | 'office-days' = 'all';
    selectedDaysFilterLabel: string = 'Filter';
    preferenceCalendarFilters: PreferenceCalendarFilterType[] = UserService.preference_calendar_filter;

    private _updateSelectedDaysFilterLabel(): void
    {
        if (this.preferenceCalendarFilters.find(f => f.name === 'no-bookings')?.isSelected) {
            this.selectedDaysFilterLabel = 'Unbooked days';
            this.selectedDaysFilter = 'no-bookings';
        } else if (this.preferenceCalendarFilters.find(f => f.name === 'excludeDaysWithNoBookings')?.isSelected) {
            this.selectedDaysFilterLabel = 'Days with bookings';
            this.selectedDaysFilter = 'bookings';
        } else if (this.preferenceCalendarFilters.find(f => f.name === 'isOfficeDays')?.isSelected) {
            this.selectedDaysFilterLabel = 'Office days';
            this.selectedDaysFilter = 'office-days';
        }
        else {
            this.selectedDaysFilterLabel = 'Filter';
            this.selectedDaysFilter = 'all';
        }
    }

    constructor(private _userService: UserService,
                private _service: TeamCalendarService,
                private _changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void
    {
        this._updateSelectedDaysFilterLabel();

        var excludeDaysWithNoBookings = false;
        var isOfficeDays = false;

        switch (this.selectedDaysFilter) {
            case 'all':
                break;
            case 'bookings':
                excludeDaysWithNoBookings = true;
                isOfficeDays = false;
                break;
            case 'no-bookings':
                excludeDaysWithNoBookings = false;
                isOfficeDays = false;
                break;
            case 'office-days':
                isOfficeDays = true;
                excludeDaysWithNoBookings = false;
                break;
        }

        this._service
            .getMyWeeks({ personId: this._userService.user.personId }, UserService.preference_includeWeekends, excludeDaysWithNoBookings, isOfficeDays, this.selectedDaysFilter)
            .subscribe();
    }

    onSelectFilterCalendarList(filter: 'all' | 'bookings' | 'no-bookings' | 'office-days'): void
    {
        this.selectedDaysFilter = filter;

        const filters = [...UserService.preference_calendar_filter];

        var excludeDaysWithNoBookings = false;
        var isOfficeDays = false;

        switch (filter) {
            case 'all':
                filters.forEach(f => f.isSelected = false);
                break;
            case 'bookings':
                excludeDaysWithNoBookings = true;
                isOfficeDays = false;
                filters.forEach(f => {
                    if (f.name === 'excludeDaysWithNoBookings') {
                        f.isSelected = true;
                    } else {
                        f.isSelected = false;
                    }
                });
                break;
            case 'no-bookings':
                excludeDaysWithNoBookings = false;
                isOfficeDays = false;
                filters.forEach(f => {
                    if (f.name === 'no-bookings') {
                        f.isSelected = true;
                    } else {
                        f.isSelected = false;
                    }
                });
                break;
            case 'office-days':
                isOfficeDays = true;
                excludeDaysWithNoBookings = false;
                filters.forEach(f => {
                    if (f.name === 'isOfficeDays') {
                        f.isSelected = true;
                    } else {
                        f.isSelected = false;
                    }
                });
                break;
        }

        UserService.preference_calendar_filter = filters;
        this.preferenceCalendarFilters = filters;

        this._updateSelectedDaysFilterLabel();

        this._service.getMyWeeks({ personId: this._userService.user.personId }, UserService.preference_includeWeekends, excludeDaysWithNoBookings, isOfficeDays, filter)
            .subscribe();
    }
}
